import { typeStrategy } from "@/common/constants/typeStrategy.constant";
import { GeoData } from "@/common/types/geoGeoable";
import { geoGetParentData, geoIdentifyTypeByObject } from "@/common/utils/geoUtils";
import { ComponentProps } from "react";

interface GeoSelectOptionProps {
  geo: GeoData;
  containerProps?: ComponentProps<'p'> & {
    "data-testid": string;
  };
}

const GeoSelectOption = ({ geo, containerProps }: GeoSelectOptionProps) => {
  return (
    <p {...containerProps}>
      {geo.display_name}
      {geoIdentifyTypeByObject(geo) === 'Geo::City' ? `/${geoGetParentData(geo)?.acronym}` : ''}

      {geoIdentifyTypeByObject(geo) && (
        <span className="italic text-xs"> ({typeStrategy[geoIdentifyTypeByObject(geo)]})</span>
      )}
    </p>
  );
};

export default GeoSelectOption;
